// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"WorkspaceQuickSearch_flexRow__3l6YO","modalBody":"WorkspaceQuickSearch_modalBody__YxZKJ","ellipsis":"WorkspaceQuickSearch_ellipsis__vSf2H"};